import React from 'react'
import { getBonusThresholdModalDescription } from '../util'
import { Checkbox } from '../../../../../Components/Form'
import boomSound from '../../../../../Assets/Sounds/vine-boom.mp3'

const ActivateCampaignModal = ({
  metrics,
  primaryMetricIndex,
  countryId,
  countries,
  payoutPerConversion,
  bonusLimit,
  bonusEnabled,
  baRedemptionPeriod,
  bonusThreshold,
  printingCostPerFlyer,
  toggleConfirmAvailabilityReduxModal,
}) => {
  let metricNamesStr = 'NOT SET'
  let primaryMetricName = 'NOT SET'
  let payoutPerConversionStr = ''
  let bonusLimitStr = ''
  let currency = ''
  if (metrics) {
    const metricNamesArr = metrics.map((metric, index) => {
      if (index === primaryMetricIndex) {
        primaryMetricName = metric.name
      }
      return metric.name
    })
    metricNamesStr = metricNamesArr.join(', ')
  }

  if (countryId) {
    const country = countries.find(({ id }) => id === countryId)
    if (country) {
      currency = country.currency
    }
  }

  if (payoutPerConversion) {
    bonusLimitStr = `${currency}${bonusLimit}`
    payoutPerConversionStr = `${currency}${payoutPerConversion}`
  }

  const checkPayoutBonus = bonus => {
    const formatedBonus = Number(bonus.slice(1))
    if (formatedBonus > 50 && countryId !== '17') {
      new Audio(boomSound).play()
      return <span style={{ color: 'red' }}>{bonus}</span>
    } else return bonus
  }

  return (
    <section className="redux-modal">
      <article>
        <p>
          This data (and more) will be set and UN-EDITABLE for this campaign:
        </p>
        <ul className="redux-modal__list">
          <li>Primary Metric: "{primaryMetricName}"</li>
          <li>Metric Names: "{metricNamesStr}"</li>
          <li>
            Conversion Bonus:
            {bonusEnabled ? (
              <ul>
                <li>ENABLED</li>
                <li>Redemption Period: {baRedemptionPeriod} weeks</li>
                <li>Bonus Allowance: {bonusLimitStr}</li>
                <li>
                  Bonus Per Conversion:
                  {checkPayoutBonus(payoutPerConversionStr)}
                </li>
                <li>
                  <li>
                    {' '}
                    Bonus Threshold:{' '}
                    {getBonusThresholdModalDescription(bonusThreshold)}
                  </li>
                </li>
              </ul>
            ) : (
              <ul>
                <li>DISABLED</li>
              </ul>
            )}
          </li>
          <li>Printing Cost Per Flyer: {printingCostPerFlyer}</li>
        </ul>
      </article>
      <footer className="redux-modal__footer">
        <Checkbox
          input={{
            onClick: toggleConfirmAvailabilityReduxModal,
          }}
          cypress_id="activate-campaign-checkbox"
        />
        <span className="redux-modal__checkbox-hint">
          I understand these CANNOT BE EDITED after activating this campaign.
        </span>
      </footer>
    </section>
  )
}

export default ActivateCampaignModal
